(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-main-blog-post"]) return;
  try {
    
  /* BAYMARD UX: Reading progress indicator */
  document.addEventListener('DOMContentLoaded', function() {
    var progressBar = document.getElementById('reading-progress');
    if (progressBar) {
      window.addEventListener('scroll', function() {
        var winScroll = document.body.scrollTop || document.documentElement.scrollTop;
        var height = document.documentElement.scrollHeight - document.documentElement.clientHeight;
        var scrolled = (winScroll / height) * 100;
        progressBar.style.width = scrolled + '%';
      });
    }

/* BAYMARD UX: Interactive ingredient checkboxes */
    document.querySelectorAll('.ms-ingredients li').forEach(function(li) {
      li.addEventListener('click', function() {
        this.classList.toggle('checked');
      });
    });

/* BAYMARD UX: Smooth scroll for jump links */
    document.querySelectorAll('.ms-jump-link').forEach(function(link) {
      link.addEventListener('click', function(e) {
        e.preventDefault();
        var target = document.querySelector(this.getAttribute('href'));
        if (target) {
          target.scrollIntoView({behavior: 'smooth', block: 'start'});
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
